import styled from 'styled-components';

export const Base = styled.div`
	display: flex;
	flex-direction: column;
	min-width: 420px;
	max-width: 520px;
	margin-top: 12px;
`;

export const Empty = styled.div`
	padding: 32px 8px;
	text-align: center;
	color: ${({ theme }) => theme.gray[700]};
	font-size: 14px;
`;

export const List = styled.div`
	display: flex;
	flex-direction: column;
	gap: 4px;
	max-height: 50vh;
	overflow-y: auto;
`;

export const Row = styled.a`
	display: flex;
	align-items: center;
	gap: 12px;
	padding: 10px 12px;
	border-radius: 6px;
	text-decoration: none;
	color: inherit;

	&:hover {
		background-color: ${({ theme }) => theme.gray[100]};
	}

	&:active {
		background-color: ${({ theme }) => theme.gray[200]};
	}
`;

// Non-clickable variant used for pending / failed export rows. Same layout as
// Row but no hover/active feedback — these rows aren't actionable.
export const InertRow = styled.div`
	display: flex;
	align-items: center;
	gap: 12px;
	padding: 10px 12px;
	border-radius: 6px;
	color: inherit;
`;

export const IconWrap = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 28px;
	height: 28px;
	border-radius: 4px;
	background-color: ${({ theme }) => theme.gray[100]};
	color: ${({ theme }) => theme.gray[900]};
	flex-shrink: 0;
`;

export const Text = styled.div`
	display: flex;
	flex-direction: column;
	gap: 2px;
	flex: 1;
	min-width: 0;
`;

export const Filename = styled.div`
	font-size: 13px;
	font-weight: 500;
	color: ${({ theme }) => theme.gray[1000]};
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
`;

export const Meta = styled.div`
	font-size: 11px;
	color: ${({ theme }) => theme.gray[700]};
`;

export const Dot = styled.div`
	width: 8px;
	height: 8px;
	border-radius: 50%;
	background-color: ${({ theme }) => theme.blue[600]};
	flex-shrink: 0;
`;
